// Resolves whether MFA setup should block the user by combining the
// organization's MFA requirement with the current user's setup status.
import { queryClient, trpc } from '@/utils/trpc';
import { getCurrentMfaSetupStatus } from './mfaStatus';

export type MfaSetupGuardResult = {
  organizationMfaEnabled: boolean;
  setupRequired: boolean;
};

export const resolveMfaSetupGuard = async (
  email: string,
): Promise<MfaSetupGuardResult> => {
  const userInfo = await queryClient.fetchQuery(
    trpc.userInfoRouter.getUserInfo.queryOptions({ email }),
  );

  const organizationMfaEnabled = userInfo?.enableMfa ?? false;

  if (!organizationMfaEnabled) {
    return { organizationMfaEnabled: false, setupRequired: false };
  }

  try {
    const mfaStatus = await getCurrentMfaSetupStatus();

    return {
      organizationMfaEnabled: true,
      setupRequired: mfaStatus.setupRequired,
    };
  } catch {
    return { organizationMfaEnabled: true, setupRequired: true };
  }
};
